import React from "react";
import "./App.css";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useLocation,
  matchPath,
} from "react-router-dom";

import Home from "./pages/home/home";
import AboutUs from "./pages/about/aboutUsPage";

import ProductPage from "./pages/products/productPage";

import ContactPage from "./pages/contact/contactPage";

import Nav from "./commponents/layout/Navbar";
import ProductSearchPage from "./pages/searchProduct/searchProductPage";
import ProjectDetailPage from "./pages/recentPorject/ProjectDetail";
import NotFoundPage from "./pages/notFound/NotFoundPage";
import ScrollToTop from "./assets/common/ScrollToTop";
import FloatingContactButtons from "./commponents/FloatingContactButtons/FloatingContactButtons";
import ProductDetailPage from "./pages/productDetail/productDetailPage";
import RecentProjectPage from "./pages/recentPorject/RecentProjectPage";
import { HomePageProvider } from "./context/HomePageContext";
import { LanguageProvider } from "./context/LanguageContext";

// Daftar path yang tidak boleh menampilkan footer.
// Tambahkan path baru di sini kalau suatu saat perlu disembunyikan juga.
const HIDDEN_FOOTER_PATTERNS = [
  "/Contact",
  "/products/:slug",
  "/Project/:id",
  "/Product/:id",
  "/ProductSearch",
];

function AppContent() {
  const location = useLocation();

  const hideFooter = HIDDEN_FOOTER_PATTERNS.some((pattern) =>
    matchPath({ path: pattern, end: true }, location.pathname),
  );

  return (
    // FIX: min-h-screen + flex-col supaya kalau konten halaman lebih
    // pendek dari tinggi layar, sisa ruangnya "diserap" oleh area
    // konten (flex-1 di bawah), bukan jadi celah kosong putih di
    // BAWAH footer. Footer jadi selalu nempel pas di bawah, dan warna
    // di sekitar sudut lengkung footer tidak perlu diubah sama sekali
    // (jadi rounded-t-[60px] tetap kelihatan seperti semula).
    <div className="flex min-h-screen flex-col">
      <ScrollToTop />
      <Nav />

      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Home" element={<Home />} />
          <Route path="/About" element={<AboutUs />} />
          <Route path="/Project" element={<RecentProjectPage />} />
          <Route path="/Project/:id" element={<ProjectDetailPage />} />
          <Route path="/products/:slug" element={<ProductPage />} />
          <Route path="/product/:id" element={<ProductDetailPage />} />
          <Route path="/Contact" element={<ContactPage />} />
          <Route path="/ProductSearch" element={<ProductSearchPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>

      <FloatingContactButtons />
    </div>
  );
}

function App() {
  return (
    <Router>
      {/* Bahasa tampilan (ID/EN) untuk seluruh website. */}
      <LanguageProvider>
        {/* Konten Home dari admin, diambil sekali untuk seluruh website. */}
        <HomePageProvider>
          <AppContent />
        </HomePageProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
